import { useContext } from "react";
import { MobileBridgeContext } from "../contexts/MobileBridgeContext";

/**
 * Returns the instance of MobileBridge passed to AppFrame.
 */
export function useMobileBridge() {
  return useContext(MobileBridgeContext);
}
